/**
 * Lazy Leaflet loader: the library (and its CSS) is only downloaded when
 * a page actually mounts a map, so regular pages pay nothing.
 */
async function leaflet() {
    const [{ default: L }] = await Promise.all([
        import('leaflet'),
        import('leaflet/dist/leaflet.css'),
    ]);

    return L;
}

const pinHtml = `
    <div style="width:26px;height:26px;transform:translate(-2px,-8px)">
        <svg viewBox="0 0 24 24" fill="#18181b" stroke="#fff" stroke-width="1.2">
            <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7Z"/>
            <circle cx="12" cy="9" r="2.6" fill="#fff" stroke="none"/>
        </svg>
    </div>`;

/**
 * Mount a map with a single pin.
 *
 * options: { lat, lng, zoom?, interactive?, onChange? }
 * Returns { map, marker, setPosition }.
 */
window.bookifyMap = async function (el, { lat, lng, zoom = 16, interactive = false, onChange = null }) {
    const L = await leaflet();

    const map = L.map(el, { scrollWheelZoom: interactive }).setView([lat, lng], zoom);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    const marker = L.marker([lat, lng], {
        draggable: interactive,
        icon: L.divIcon({ className: '', html: pinHtml, iconSize: [26, 26], iconAnchor: [13, 24] }),
    }).addTo(map);

    if (interactive) {
        marker.on('dragend', () => onChange?.(marker.getLatLng()));
        map.on('click', (e) => {
            marker.setLatLng(e.latlng);
            onChange?.(e.latlng);
        });
    }

    // Maps mounted inside modals start at size 0 — recalc once visible.
    setTimeout(() => map.invalidateSize(), 150);

    return {
        map,
        marker,
        setPosition(newLat, newLng) {
            marker.setLatLng([newLat, newLng]);
            map.setView([newLat, newLng], zoom);
        },
    };
};
